export interface TestInvitationDataUploadInfo {
  success: boolean;
  errorMessage?: string;
  errors: string[];
}
